var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.item.children),function(child){return _c(_vm.resolveNavItemComponent(child),{key:child.subheader || child.title,tag:"component",attrs:{"item":child}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }